export default __webpack_public_path__ + "static/media/hitch_implement_G.72729292.svg";